import styled from 'styled-components/macro';

export const EditorWrapper = styled.main`
  flex: 1;
  box-shadow: var(--card-shadow);
  background-color: var(--color-white);
  padding: 1rem 3rem;
  border-radius: 10px;
`;
export const EditorInner = styled.div``;
